/** The selection mode of a label group. */
export const LabelGroupType = {
  singleSelect: "singleSelect",
  multiSelect: "multiSelect",
} as const;

/** A selection mode for a label group. */
export type LabelGroupType = (typeof LabelGroupType)[keyof typeof LabelGroupType];
